import { ref } from 'vue'

const claimedDeals = ref([])
export function useDealClaim () {
	const claimDeal = (dealId) => {
		claimedDeals.value.push(Number(dealId))
	}
	return { claimDeal, claimedDeals }
}
